export default __webpack_public_path__ + "article1.f5a3aca4.svg";